import { Button, Row, Col } from "react-bootstrap";
import { buttons } from "./utils/utils";
import calcReducer, { initialState } from "./hooks/calcReducer";
import { useReducer } from "react";

function App() {
  const [state, dispatch] = useReducer(calcReducer, initialState);

  const { prevVal, currentVal, currentOperand } = state;
  let disabledActionInput = false;
  if(prevVal === '' && currentVal === '') disabledActionInput = true;

  return (
    <>
      <header className="py-3 mb-5 bg-danger text-white">
        <div className="container">
          <h1 className="text-center">React Calculator</h1>
        </div>
      </header>
      <main>
        <div className="container">
          <div className="calc d-flex flex-column gap-4">
            <div className="calc-output d-flex flex-column">
              <div className="calc-output-prev flex-grow-1 text-end p-2 pe-3">{`${prevVal}${currentOperand}`}</div>
              <div className="calc-output-current flex-grow-1 text-end p-2 pe-3">{`${currentVal}`}</div>
            </div>
            <Row className="calc-action">
              {buttons.map(({ id, title, action, color, value }) => (
                <Col key={id} xs={ id === 'zero' ? 6 : 3}>
                  <Button
                    className="w-100 p-4 mb-3"
                    size="lg"
                    variant={color === "primary" ? "warning" : "dark"}
                    disabled={action !== 'INPUT_NUMBER' && disabledActionInput}
                    onClick={evt => dispatch({ type: action, payload: value })}
                  >
                    {title}
                  </Button>
                </Col>
              ))}
            </Row>
          </div>
        </div>
      </main>
    </>
  );
}

export default App;
